<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="feature-item-list" [class.compact]="compact" [class.small]="smallIcons">
    <div
      class="feature-item-list-item"
      animateInView="up"
      *ngFor="let feature of items"
      [appStoryblok]="feature._editable"
    >
      <img
        *ngIf="feature.image?.filename"
        [src]="feature.image.filename | replaceText : replacer | storyblokCdn"
        [alt]="feature.image.alt"
        width="96"
        height="96"
      />
      <b>{{ feature.title | replaceText : replacer }}</b>
      <p>{{ feature.text | replaceText : replacer }}</p>
      <div class="empty-feature-item-list" *ngIf="!feature.title">EMPTY FEATURE ITEM</div>
    </div>
  </div>
  <div class="empty-feature-item-list" *ngIf="items && !items.length">EMPTY FEATURE ITEM LIST</div>
</app-block-wrapper>
